// Helper for the parent-facing create flow (picture-book and comic): every event carries `flow`.
import { track } from '@/utils/analytics';
import type { CreateFlow, TrackProps } from '@/utils/analytics-events';

export type CreateFlowEvent =
  | 'create_step_viewed' | 'photo_uploaded' | 'faces_detected' | 'people_confirmed'
  | 'suggestion_kept' | 'suggestion_edited' | 'idea_shuffled' | 'template_picked'
  | 'preview_requested' | 'preview_ready' | 'preview_failed' | 'legal_match_shown'
  | 'cover_redraw' | 'dedication_saved' | 'template_preselected' | 'typed_relative_notice' | 'central_role_missing';

/** Track a create-flow event with its flow. Analytics must never break the flow, so this never throws. */
export function trackCreate(flow: CreateFlow, name: CreateFlowEvent, props?: Omit<TrackProps, 'flow'>): void {
  try {
    track(name, { ...props, flow });
  } catch {
    /* analytics only */
  }
}

/** Parse the `flow` checkout URL param; anything unknown is null. */
export function checkoutFlowParam(v: string | null | undefined): CreateFlow | null {
  return v === 'comic' || v === 'picture-book' ? v : null;
}
